<template>
  <div>
    <span v-for="(sg, index) in singerList" :key="sg.id">
      <el-popover
        v-if="showDetail"
        placement="right"
        trigger="hover"
      >
        <span slot="reference" style="color: #4071ff">{{ sg[nameKey] }}</span>
        <!-- 展示艺人封面、艺人ID、艺人名、翻译名、活跃地区、性别 -->
        <div class="desc">
          <img v-if="sg.photoUrl" :src="sg.photoUrl" class="img">
          <p>艺人ID: {{ sg[idKey] }}</p>
          <p>艺人名: {{ sg[nameKey] }}</p>
          <p>翻译名: {{ sg.transName }}</p>
          <p>活跃地区: {{ areaMap[sg.area] }}</p>
        </div>
      </el-popover>
      <span v-else>{{ sg[nameKey] }}</span>
      <span v-if="index !== singerList.length - 1">、</span>
    </span>
  </div>
</template>

<script>
import {
  actorTypeMap,
  areaMap,
} from '@/views/singer/mixin.js'

export default {
  name: 'SingerCell',
  props: {
    singerList: {
      type: Array,
      default() {
        return []
      }
    },
    idKey: {
      type: String,
      default: 'singerId'
    },
    nameKey: {
      type: String,
      default: 'singerName'
    },
    showDetail: Boolean
  },
  data() {
    return {
      actorTypeMap,
      areaMap,
    }
  }
}
</script>

<style lang="scss" scoped>
.desc {
  // padding: 8px;
  .img {
    width: 126px;
    height: 126px;
    margin-bottom: 12px;
  }
}
</style>
